import { render, staticRenderFns } from "./ProjectCalendar.vue?vue&type=template&id=b4bc63cc&scoped=true&"
import script from "./ProjectCalendar.vue?vue&type=script&lang=js&"
export * from "./ProjectCalendar.vue?vue&type=script&lang=js&"
import style0 from "./ProjectCalendar.vue?vue&type=style&index=0&id=b4bc63cc&scoped=true&lang=scss&"
import style1 from "./ProjectCalendar.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4bc63cc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCalendar } from 'vuetify/lib/components/VCalendar';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VCalendar,VMenu})
